module.exports = __webpack_public_path__ + "img/lastUpdateIcon.8c1a1dbc.svg";